import React, { useContext, memo } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Panel from '@prisjakt/ui-panel';
import PanelHeader from '@prisjakt/ui-panel-header';
import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';

import Recommendations from './components/recommendations';

import { trackProductRecommendationClicked } from './tracking';

import { ProductRecommendation, RecommendedProduct } from '../../types';
import { ModelType, ModelTypeEnum } from './types';

import * as S from './styles';

type Link = {
  title: string;
  url: string;
  onClick?: () => void;
};

type OwnProps = {
  contextId: string;
  link?: Link | null;
  recommendations: ProductRecommendation[];
  type: ModelType;
};

const RecommendationModel = ({
  contextId,
  link,
  recommendations,
  type,
}: OwnProps) => {
  const { t } = useContext(AppContext);

  const renderLink = () => {
    if (!link) return null;
    return (
      <S.Link to={link.url} rel="nofollow" onClick={link?.onClick}>
        {link.title}
      </S.Link>
    );
  };

  const handleProductClick = (product: RecommendedProduct) =>
    trackProductRecommendationClicked(contextId, product.id, type);

  const renderRecommendations = () => {
    if (!recommendations?.length) return null;

    switch (type) {
      case ModelTypeEnum.SIMILAR_PRODUCTS:
        return (
          <Recommendations
            columns={6}
            items={recommendations}
            limit={6}
            onClick={handleProductClick}
          />
        );
      case ModelTypeEnum.OTHERS_VISITED:
        return (
          <Recommendations
            columns={6}
            items={recommendations}
            limit={6}
            onClick={handleProductClick}
          />
        );
      case ModelTypeEnum.PERSONALIZED:
        return (
          <Recommendations
            columns={4}
            items={recommendations}
            onClick={handleProductClick}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <Panel
        data-test-type="product-recommendations"
        header={
          <PanelHeader
            title={t(
              'product',
              `recommendations.${type as ModelType}` as keyof ParamsAndReturnTypes['product']
            )}
          >
            {link && renderLink()}
          </PanelHeader>
        }
      >
        <S.ProductList>{renderRecommendations()}</S.ProductList>
      </Panel>
    </div>
  );
};

export default memo(RecommendationModel);
